import { createFileRoute } from '@tanstack/react-router'
import { DashboardScreen} from '@web/app/features/dashboard'

export const Route = createFileRoute('/_index/')({
  component: RouteComponent,
})
function RouteComponent() {
  return <DashboardScreen />
}
